/* BHB: normalizarea interogarilor de cautare.
   Problema masurata: "torx 30" -> 0 rezultate (tot catalogul e "TX30"),
   "3.5x35" -> 0 (catalogul scrie "3,5 x 35").
   Rezolvarea completa e normalizarea titlurilor + sinonime in Search &
   Discovery (proiect de date). Pana atunci, transcriem AICI interogarea
   in dialectul catalogului, pe drum - textul tastat de client ramane neatins.
   Se aplica atat sugestiilor live (/search/suggest) cat si paginii /search. */
(function () {
  'use strict';

  function normalize(q) {
    if (!q) return q;
    var out = q
      // torx 30 / Torx30 -> tx30 (catalogul foloseste TX30)
      .replace(/\btorx\s*(\d+)/gi, 'tx$1')
      .replace(/\btorx\b/gi, 'tx')
      // semnul de inmultire -> x simplu (apare copiat din titluri)
      .replace(/×/g, 'x')
      // zecimale cu punct -> virgula, conventia catalogului (3.5 -> 3,5)
      .replace(/(\d)\.(\d)/g, '$1,$2');
    return out;
  }

  // 1. Sugestiile live: rescriem parametrul q din cererile catre /search/suggest
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    try {
      var url = typeof input === 'string' ? input : (input && input.url);
      if (url && url.indexOf('/search/suggest') !== -1) {
        var u = new URL(url, location.origin);
        var q = u.searchParams.get('q');
        var nq = normalize(q);
        if (nq && nq !== q) {
          u.searchParams.set('q', nq);
          input = typeof input === 'string' ? u.toString() : new Request(u.toString(), input);
        }
      }
    } catch (e) { /* niciodata nu blocam cautarea din cauza normalizarii */ }
    return origFetch.call(this, input, init);
  };

  // 2. Trimiterea formularului de cautare: normalizam q inainte de navigare
  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || !form.action || form.action.indexOf('/search') === -1) return;
    var field = form.querySelector('input[name="q"]');
    if (!field) return;
    var nq = normalize(field.value);
    if (nq !== field.value) field.value = nq;
  }, true);
})();
